import store from './store';
import * as cards from './cards.slice'
import { getItems } from '../db/db';


export const setRemoveCardVerification = ({ 
  cardId = false,
  toBeRemoved = false
}) =>
  store.dispatch(cards.removeCardVerification({
    cardId,
    toBeRemoved
  }))

export const loadCards = async () => {
  const items = await getItems('cardId');
  store.dispatch(cards.setCards(items));
};

export const openAddCard = () => 
  store.dispatch(cards.setEditCardId('cardId-'+Math.random()));

export const closeAddCard = () => 
  store.dispatch(cards.setEditCardId(null));

export const editCard = (cardId) => 
  store.dispatch(cards.setEditCardId(cardId));

export const refreshCards = loadCards;